import { ReactElement } from 'react';

import { Button, ButtonVariant } from '@dreryk/react-components';

import { translationKeys } from './translations';

export const ConfidentialAccessPendingButton = (): ReactElement => {
   return (
      <Button
         testId={'confidentialAccessPending'}
         variant={ButtonVariant.SECONDARY}
         disabled
         compact
         label={translationKeys.confidentialAccessPending}
      />
   );
};
